export function getEndpoint() {
    return 'https://api-champ.shopappservers.com'
    
}